"use strict";

module.exports = function (fn) {
  return function () {
    return !fn.apply(undefined, arguments);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/complement.js
// module id = 1040
// module chunks = 37